import React, { useEffect } from "react";

function Testimonial() {
  useEffect(() => {
    if (window.$) {
      window.$(".three-item-carousel").owlCarousel({
        items: 3,
        loop: true,
        autoplay: true,
        margin: 30,
        dots: true,
        nav: false,
        responsive: {
          0: { items: 1 },
          768: { items: 2 },
          1024: { items: 3 },
        },
      });
    }
  }, []);

  return (
    <section
      className="testimonial_section"
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="500"
    >
      <div className="container">
        <div className="shape_bg"></div>
        <div className="section_title centred">
          <div className="tag_text">
            <h6>Testimonials</h6>
          </div>
          <h2>What Our Clients Say</h2>
        </div>

        <div className="three-item-carousel owl-carousel owl-theme owl-dots-one owl-nav-none">
          {/* Testimonial 1 */}
          <div className="testimonial_block_one">
            <div className="inner_box">
              <ul className="rating">
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <i class="fa-solid fa-star"></i>
                  </li>
                ))}
              </ul>
              <p>
                I have seen consistent returns and improved portfolio
                diversification thanks to their expert guidance and cutting-edge
                tools.
              </p>
              <div className="author_box">
                <div className="author_info">
                  <h5>David P.</h5>
                  <span className="designation">
                    Investor <span>(Premium Capital Group)</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="testimonial_block_one">
            <div className="inner_box">
              <ul className="rating">
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <i class="fa-solid fa-star"></i>
                  </li>
                ))}
              </ul>
              <p>
                Their insights into market trends and risk management allowed me
                to confidently invest and scale my startup faster than I ever
                expected.
              </p>
              <div className="author_box">
                <div className="author_info">
                  <h5>Sarah K.</h5>
                  <span className="designation">
                    Entrepreneur <span>(Digital Innovations Inc.)</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="testimonial_block_one">
            <div className="inner_box">
              <ul className="rating">
                {[...Array(5)].map((_, i) => (
                  <li key={i}>
                    <i class="fa-solid fa-star"></i>
                  </li>
                ))}
              </ul>
              <p>
                Eco Mantra Capital algorithm saved me ₹15,000 in interest on my
                business expansion loan while simultaneously.
              </p>
              <div className="author_box">
                <div className="author_info">
                  <h5>Michael T.</h5>
                  <span className="designation">
                    Small Business Owner <span>(TechStart Solutions)</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
